const RESPONSIVE_IMG_STYLE =
  'max-width:100%;width:100%;height:auto;display:block;object-fit:contain;'

const stripSizeFromStyle = (style: string) =>
  style
    .replace(/(?:^|;)\s*(?:width|height|min-width|max-width)\s*:[^;]+;?/gi, ';')
    .replace(/;+/g, ';')
    .replace(/^;|;$/g, '')
    .trim()

/**
 * TipTap/backoffice HTML often ships fixed pixel widths on <img>, which overflow in modals.
 * Normalizes attributes and inline styles so images fit the container width.
 */
export const normalizeTermsDescriptionHtml = (html: string) => {
  if (!html?.trim()) return html

  return html.replace(/<img\b([^>]*?)\/?>/gi, (_match, attrs: string) => {
    let cleanAttrs = attrs
      .replace(/\s(width|height)=["'][^"']*["']/gi, '')
      .replace(/\s(width|height)=\S+/gi, '')

    const styleMatch = cleanAttrs.match(/style=(["'])([\s\S]*?)\1/i)

    if (styleMatch) {
      const merged = [stripSizeFromStyle(styleMatch[2]), RESPONSIVE_IMG_STYLE]
        .filter(Boolean)
        .join(';')

      cleanAttrs = cleanAttrs.replace(/style=(["'])([\s\S]*?)\1/i, `style="${merged}"`)
    } else {
      cleanAttrs += ` style="${RESPONSIVE_IMG_STYLE}"`
    }

    return `<img${cleanAttrs} />`
  })
}
